import React from "react";

const HVACHowToOpen = () => {
  return (
    <div className="min-h-screen bg-black text-gray-200 px-4 py-2 [&>p]:text-white">

      {/* Header */}
      <header className="mb-8">
        <h1 className="text-xl lg:text-2xl font-bold text-yellow-200 flex items-center gap-3">
          <i className="fa-solid fa-industry text-cyan-400"></i>
          Open an HVAC Enterprise in India
        </h1>
        <p className="mt-3 text-sm text-gray-200 leading-relaxed">
          A complete, ground-level guide to starting an HVAC
          <strong> Product</strong>, <strong>Trading</strong>, or
          <strong> Service</strong> business in India.
        </p>
      </header>

      {/* Business Types */}
      <section className="mb-8">
        <h2 className="text-lg lg:text-xl font-semibold text-yellow-300 flex items-center gap-2 mb-2">
          <i className="fa-solid fa-layer-group text-blue-400"></i>
          Types of HVAC Businesses
        </h2>

        <div className="grid grid-cols-1 gap-3 text-sm text-white [&>p]:text-white">
          <p>• HVAC Manufacturing / Product Company</p>
          <p>• HVAC Trading & Distribution</p>
          <p>• HVAC Installation & Contracting</p>
          <p>• HVAC Service, Repair & AMC</p>
          <p>• HVAC Design, Audit & Consulting</p>
        </div>
      </section>

      {/* Step 1 */}
      <section className="mb-8">
        <h2 className="text-lg lg:text-xl font-semibold text-yellow-300 flex items-center gap-2 mb-2">
          <i className="fa-solid fa-compass text-green-400"></i>
          Step 1: Decide Business Model
        </h2>

        <div className="space-y-2 text-sm text-white [&>p]:text-white">
          <p>• Residential / Commercial / Industrial focus</p>
          <p>• Product vs Project vs Service revenue</p>
          <p>• Own brand vs Authorized dealer</p>
          <p>• Local city vs Pan-India operations</p>
        </div>
      </section>

      {/* Step 2 */}
      <section className="mb-8">
        <h2 className="text-lg lg:text-xl font-semibold text-yellow-300 flex items-center gap-2 mb-2">
          <i className="fa-solid fa-building-user text-yellow-400"></i>
          Step 2: Company Registration
        </h2>

        <div className="space-y-2 text-sm text-white [&>p]:text-white">
          <p>• Proprietorship / Partnership / LLP / Pvt Ltd</p>
          <p>• Register via MCA Portal (India)</p>
          <p>• Obtain PAN & TAN</p>
          <p>• Open Current Bank Account</p>
        </div>
      </section>

      {/* Step 3 */}
      <section className="mb-8">
        <h2 className="text-lg lg:text-xl font-semibold text-yellow-300 flex items-center gap-2 mb-2">
          <i className="fa-solid fa-file-shield text-red-400"></i>
          Step 3: Licenses & Compliance
        </h2>

        <div className="grid grid-cols-1 gap-2 text-sm text-white [&>p]:text-white">
          <p>• GST Registration (Mandatory)</p>
          <p>• MSME / Udyam Registration</p>
          <p>• Trade License (Local Municipality)</p>
          <p>• Shop & Establishment Act</p>
          <p>• Pollution Control (if manufacturing)</p>
          <p>• BIS / BEE (for HVAC products)</p>
        </div>
      </section>

      {/* Step 4 */}
      <section className="mb-8">
        <h2 className="text-lg lg:text-xl font-semibold text-yellow-300 flex items-center gap-2 mb-2">
          <i className="fa-solid fa-toolbox text-orange-400"></i>
          Step 4: Infrastructure & Tools
        </h2>

        <div className="space-y-2 text-sm text-white [&>p]:text-white">
          <p>• Office + Warehouse / Workshop</p>
          <p>• Installation & Service Tools</p>
          <p>• Refrigerant handling & safety kits</p>
          <p>• CRM, BMS & Service Management Software</p>
        </div>
      </section>

      {/* Step 5 */}
      <section className="mb-8">
        <h2 className="text-lg lg:text-xl font-semibold text-yellow-300 flex items-center gap-2 mb-2">
          <i className="fa-solid fa-people-group text-purple-400"></i>
          Step 5: Hiring & Skills
        </h2>

        <div className="space-y-2 text-sm text-white [&>p]:text-white">
          <p>• HVAC Engineers</p>
          <p>• Technicians & Helpers</p>
          <p>• Sales & Project Managers</p>
          <p>• Safety & Compliance Officers</p>
        </div>
      </section>

      {/* Step 6 */}
      <section className="mb-8">
        <h2 className="text-lg lg:text-xl font-semibold text-yellow-300 flex items-center gap-2 mb-2">
          <i className="fa-solid fa-indian-rupee-sign text-emerald-400"></i>
          Step 6: Funding & Finance
        </h2>

        <div className="space-y-2 text-sm text-white [&>p]:text-white">
          <p>• Self-funding / Bootstrapping</p>
          <p>• MSME Loans & Mudra</p>
          <p>• SIDBI / NBFC Financing</p>
          <p>• Vendor Credit & OEM Support</p>
        </div>
      </section>

      {/* Step 7 */}
      <section className="mb-8">
        <h2 className="text-lg lg:text-xl font-semibold text-yellow-300 flex items-center gap-2 mb-2">
          <i className="fa-solid fa-bullhorn text-pink-400"></i>
          Step 7: Go-to-Market
        </h2>

        <div className="space-y-2 text-sm text-white [&>p]:text-white">
          <p>• OEM Tie-ups & Dealerships</p>
          <p>• Builders, Architects & Consultants</p>
          <p>• AMC Contracts & Retainers</p>
          <p>• Digital Marketing & Local SEO</p>
        </div>
      </section>

      {/* Think5Whys Fit */}
      <section className="mb-10">
        <h2 className="text-lg lg:text-xl font-semibold text-yellow-300 flex items-center gap-2 mb-2">
          <i className="fa-solid fa-brain text-cyan-400"></i>
          Where Think5Whys TaaP Fits
        </h2>

        <div className="space-y-2 text-sm text-white [&>p]:text-white">
          <p>• L&D for technicians & owners</p>
          <p>• Compliance tracking & audits</p>
          <p>• Project & AMC lifecycle management</p>
          <p>• ESG, Sustainability & Energy reporting</p>
          <p>• Marketplace + MSME Connect</p>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-gray-800 pt-4">
        <p className="text-xs text-white text-center">
          HVAC entrepreneurship is no longer just trade — it is
          infrastructure, climate responsibility, and digital execution.
        </p>
      </footer>

    </div>
  );
};

export default HVACHowToOpen;
